(function () {
  var bloecke = document.querySelectorAll('[data-fck]');

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (z) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[z];
    });
  }

  bloecke.forEach(function (block) {
    if (block.__fck) return;
    block.__fck = true;

    var proxy = (window.FinderClean && window.FinderClean.proxy) ||
                block.getAttribute('data-fck-proxy-fallback') || '/apps/monitor-db';

    var TX = {};
    try { TX = JSON.parse((block.querySelector('[data-fck-texte]') || {}).textContent || '{}') || {}; } catch (e) {}
    function tx(k, ersatz, werte) {
      var s = TX[k] || ersatz || '';
      Object.keys(werte || {}).forEach(function (w) { s = s.split('{' + w + '}').join(werte[w]); });
      return s;
    }
    var WURZEL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

    function bildAdresse(u) {
      if (typeof u !== 'string' || !u) return '';
      return u.indexOf('/media/') === 0 ? proxy + u : u;
    }

    function abruf(url) {
      if (window.EngineStatus) return window.EngineStatus.hol(url);
      return fetch(url).then(function (r) { return r.json(); });
    }

    function ausfall(e) {
      return !!(e && e.engineAus && window.EngineStatus);
    }

    var WA_TEXT = TX.wa_text ? TX.wa_text + ' ' : 'Hallo, ich brauche Hilfe bei der Passung. Mein Monitor ist: ';

    var refsEl = block.querySelector('[data-fck-refs]');
    var refs = [];
    if (refsEl) { try { refs = JSON.parse(refsEl.textContent) || []; } catch (e) {} }

    var eingabe = block.querySelector('[data-fck-input]');
    var form = block.querySelector('[data-fck-form]');
    var bereich = block.querySelector('[data-fck-eingabe]');
    var treffer = block.querySelector('[data-fck-treffer]');
    var uhr = null, letzte = '';

    var feldzone  = block.querySelector('.fck__feld') || form;

    var erg        = block.querySelector('[data-fck-erg]');
    var zeilenEl   = block.querySelector('[data-fck-zeilen]');
    var kopfNeuEl    = block.querySelector('.fck__kopf-neu');
    var vfEl       = block.querySelector('[data-fck-vf]');
    var vfHeim     = vfEl ? vfEl.parentNode : null;
    var uniEl      = block.querySelector('[data-fck-universell]');

    var universell  = block.getAttribute('data-fck-scope') === 'universal';
    var eigeneSku   = (block.getAttribute('data-fck-sku') || '').trim().toLowerCase();
    var finderUrl   = block.getAttribute('data-fck-finder') || '/pages/setup-finder';
    var serviceHref = (block.getAttribute('data-fck-service-href') || '').trim();
    var serviceText = (block.getAttribute('data-fck-service-text') || '').trim();
    var absageKnopf = (block.getAttribute('data-fck-absage-knopf') || '').trim();
    var rolle       = (block.getAttribute('data-fck-rolle') || 'passung').trim();
    var setupWort   = (block.getAttribute('data-fck-setup-wort') || '').trim();
    var frageWort   = (block.getAttribute('data-fck-frage') || '').trim()
                      || 'Passt das zu deinem Monitor?';

    if (rolle === 'setup' && vfEl) {
      vfEl.remove();
      vfEl = null;
      vfHeim = null;
    }

    function zeigeEingabe() {
      if (erg) erg.hidden = true;
      if (bereich) bereich.hidden = false;
      if (uniEl) uniEl.hidden = false;
      if (treffer) { treffer.hidden = true; treffer.innerHTML = ''; }
      if (eingabe) eingabe.value = '';

      block.classList.remove('fck--ergebnis');
      if (vfEl) vfEl.hidden = true;
      var neuEl = block.querySelector('[data-fenster-auf="setup"]:not([data-fck-arb-knopf])');
      if (neuEl) neuEl.hidden = true;
      if (zeilenEl) zeilenEl.innerHTML = '';
      faltZeigen(null);
    }

    if (window.Suchebene && eingabe && treffer && feldzone) {
      window.Suchebene.binden({
        leiste: feldzone,
        eingabe: eingabe,
        liste: treffer,
        zu: function () { treffer.hidden = true; treffer.innerHTML = ''; },
        titel: frageWort
      });
    }

    function wortAus(name, vorgabe) {
      var v = block.getAttribute('data-fck-wort-' + name);
      return v && v.trim() ? v : vorgabe;
    }
    var WORT = { ok: wortAus('ok', tx('kompatibel', 'Kompatibel')),
                 rec: wortAus('rec', tx('empfohlen', 'Empfohlen')),
                 warn: wortAus('warn', tx('nicht_kompatibel', 'Nicht kompatibel')),
                 neutral: wortAus('neutral', tx('nicht_kompatibel', 'Nicht kompatibel')) };
    var letzterName = '';
    var letzteAnzahl = 0;

    var ZEICHEN = { ok: '\u2713', warn: '\u2715', rec: '', neutral: '\u2013' };

    var letztesErgebnis = [];

    var faltEl    = block.querySelector('.fck__falt');
    var faltSig   = block.querySelector('[data-fck-falt-sig]');
    var faltTitel = block.querySelector('[data-fck-falt-titel]');
    var faltSatz  = block.querySelector('[data-fck-falt-satz]');
    var faltNotiz = block.querySelector('[data-fck-falt-notiz]');

    function attr(name, vorgabe) {
      var v = block.getAttribute('data-fck-' + name);
      return v && v.trim() ? v : vorgabe;
    }

    function faltZeigen(stand, name, anzahl) {
      if (!faltEl || !faltTitel) return;

      if (!stand) {
        block.removeAttribute('data-fck-stand');
        faltTitel.textContent = attr('zu-titel', 'Passt dein Monitor?');
        faltSatz.textContent  = attr('zu-text', '');
        faltNotiz.textContent = attr('zu-notiz', '');
        faltSig.hidden = true;
        faltSig.textContent = '';
        return;
      }

      if (stand === 'laedt') {
        block.setAttribute('data-fck-stand', 'laedt');
        faltTitel.textContent = attr('kopf-laedt', 'Kompatibilität wird geprüft …');
        faltSatz.textContent  = '';
        faltNotiz.textContent = '';
        faltSig.hidden = true;
        faltSig.textContent = '';
        return;
      }

      block.setAttribute('data-fck-stand', stand);
      var text = attr('kopf-' + stand, '');
      if (!text) text = WORT[stand] || '';

      var wen = name || '';
      if (anzahl > 1) wen = wen + ' + ' + (anzahl - 1) + ' weitere';
      faltTitel.textContent = text.replace('{monitor}', wen).replace(/\s+/g, ' ').trim();

      faltSatz.textContent  = attr('satz-' + stand, '');
      faltNotiz.textContent = '';

      var z = ZEICHEN[stand];
      if (stand === 'rec') z = '!';
      if (stand === 'neutral') z = '?';
      faltSig.textContent = z || '';
      faltSig.hidden = !z;

      if (stand !== 'ok') faltEl.open = true;
    }

    var geraet = {};

    function geraetHolen(ref) {
      if (geraet[ref]) return Promise.resolve(geraet[ref]);
      return abruf(proxy + '/monitors/' + encodeURIComponent(ref))
        .then(function (json) {
          var d = (json && json.ok && json.data) || {};
          geraet[ref] = {
            bild: bildAdresse(d.image_url),
            groesse: d.size_inch ? String(parseFloat(d.size_inch)).replace('.', ',') + '"' : '',
            gewicht: d.weight_g ? String(Math.round(d.weight_g / 100) / 10).replace('.', ',') + ' kg' : '',
            vesa: d.vesa || null
          };
          return geraet[ref];
        })
        .catch(function () {
          geraet[ref] = { bild: '', groesse: '', gewicht: '', vesa: null };
          return geraet[ref];
        });
    }

    function vesaZeichen(ref) {
      var v = (geraet[ref] || {}).vesa;
      if (!v) return '';
      if (v.mount === 'NO') {
        return '<span class="fn-vesa-chip is-static is-none"><span>'
             + esc(block.getAttribute('data-fck-wort-novesa') || 'Kein VESA') + '</span></span>';
      }
      if (v.patterns && v.patterns.length) {
        return '<span class="fn-vesa-chip is-static is-ok"><span>'
             + esc('VESA ' + v.patterns[0]) + '</span></span>';
      }
      return '';
    }

    function setupZeile(r) {
      var d = geraet[r.ref] || {};
      var unten = [d.groesse, d.gewicht].filter(Boolean).join(' · ');
      var zeile = document.createElement('div');
      zeile.className = 'stf__zeile fck__stf-zeile';
      zeile.innerHTML =
          '<span class="stf__bild">'
        +   (d.bild ? '<img src="' + esc(d.bild) + '" alt="" loading="lazy">' : MONITOR_SVG)
        + '</span>'
        + '<span class="stf__txt">'
        +   '<span class="stf__name">'
        +     esc((r.anzahl > 1 ? r.anzahl + '× ' : '') + (r.name || '')) + '</span>'
        +   '<span class="stf__daten">' + esc(unten) + '</span>'
        + '</span>'
        + vesaZeichen(r.ref);
      return zeile;
    }

    var MONITOR_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" '
      + 'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + '<rect x="3" y="4" width="18" height="12" rx="2"></rect>'
      + '<path d="M8 20h8M12 16v4"></path></svg>';

    function fuelleStatus(el, r) {
      var wort = r.wort || WORT[r.stufe] || WORT.rec;
      var zeichen = ZEICHEN[r.stufe];

      var loesbar = r.stufe !== 'warn' || (r.alternativen || []).length > 0;
      if (rolle === 'setup' && loesbar && setupWort) {
        wort = setupWort;
        zeichen = ZEICHEN.ok;
      }

      if (zeichen) {
        var zei = document.createElement('i');
        zei.setAttribute('aria-hidden', 'true');
        zei.textContent = zeichen;
        el.appendChild(zei);
      }
      el.appendChild(document.createTextNode(wort));
    }

    function zeigeAlle(liste) {
      if (!erg || !zeilenEl) return;
      liste = (liste || []).filter(Boolean);

      if (!liste.length) {
        if (rolle === 'setup') faltZeigen(null);
        if (letzteAnzahl > 0 && rolle !== 'setup') {
          faltZeigen('ok', letzterName, letzteAnzahl);

          if (bereich) bereich.hidden = true;
          if (uniEl) uniEl.hidden = true;
          var neuEl2 = block.querySelector('[data-fenster-auf="setup"]:not([data-fck-arb-knopf])');
          if (neuEl2) neuEl2.hidden = false;
          block.classList.add('fck--ergebnis');
        }
        return;
      }
      letztesErgebnis = liste;

      if (bereich) bereich.hidden = true;
      if (uniEl) uniEl.hidden = true;

      var stufe = 'ok';
      liste.forEach(function (r) {
        if (r.stufe === 'warn') stufe = 'warn';
        else if (r.stufe === 'rec' && stufe !== 'warn') stufe = 'rec';
      });
      erg.className = 'fck__erg fck__erg--' + (rolle === 'setup' ? 'ok' : stufe);

      if (rolle !== 'setup') {
        var RANG = { ok: 0, rec: 1, neutral: 2, warn: 3 };
        var faltStand = 'ok';
        liste.forEach(function (r) {
          var s = r && r.stufe;
          if (s && RANG[s] > RANG[faltStand]) faltStand = s;
        });
        faltZeigen(faltStand, letzterName, liste.length);
      } else {
        faltZeigen(null);
      }

      block.classList.add('fck--ergebnis');

      zeilenEl.className = 'fck__zeilen';
      zeilenEl.innerHTML = '';

      var loesbar = liste.filter(function (r) {
        return r.stufe !== 'warn' || !!(r.karten && String(r.karten).trim());
      }).length;
      var sackgasse = loesbar === 0;

      var seiteBedient = liste.some(function (r) {
        return r && r.stufe !== 'warn' && r.stufe !== 'neutral' && r.stufe !== 'rec';
      });

      liste.forEach(function (r) {
        if (rolle === 'setup') {
          var sz = setupZeile(r);
          zeilenEl.appendChild(sz);
          sz.setAttribute('data-fck-z', '');
          if (!geraet[r.ref]) {
            geraetHolen(r.ref).then(function () {
              if (!sz.parentNode) return;
              var neu = setupZeile(r);
              neu.setAttribute('data-fck-z', '');
              sz.parentNode.replaceChild(neu, sz);
            });
          }
          return;
        }

        var zeile = document.createElement('div');
        zeile.className = 'fck__z-zeile';

        var nameEl = document.createElement('span');
        nameEl.className = 'fck__z-modell';
        nameEl.innerHTML = MONITOR_SVG;
        nameEl.appendChild(document.createTextNode(
          (r.anzahl > 1 ? r.anzahl + '× ' : '') + (r.name || '')));
        zeile.appendChild(nameEl);

        var linie = document.createElement('span');
        linie.className = 'fck__z-linie';
        linie.setAttribute('aria-hidden', 'true');
        zeile.appendChild(linie);

        var st = document.createElement('span');
        st.className = 'fck__z-status fck__z-status--' + r.stufe;
        fuelleStatus(st, r);
        zeile.appendChild(st);
        zeilenEl.appendChild(zeile);
        zeile.setAttribute('data-fck-z', '');

        if (rolle === 'setup') return;

        if (r.kurz || r.karten || r.weiter || (sackgasse && r.zweitweg)) {
          var an = document.createElement('div');
          an.className = 'fck__z-anhang';
          if (r.kurz) {
            var k = document.createElement('small');
            k.className = 'fck__z-kurz';
            k.textContent = r.kurz;
            an.appendChild(k);
          }
          if (r.karten && !document.querySelector('[data-sku], [data-ost]')) {
            var kk = document.createElement('div');
            kk.className = 'fck__karten';
            kk.innerHTML = '<span class="fck__karten-kopf">'
              + (r.kartenkopf || esc(tx('passender_adapter', 'Passender Adapter'))) + '</span>' + r.karten;
            if (r.anzahl > 1) {
              kk.querySelectorAll('[data-mini-handle]').forEach(function (karte) {
                karte.setAttribute('data-mini-anzahl', r.anzahl);
              });
            }
            an.appendChild(kk);
            bilderNachladen(kk);
          } else if (r.karten) {
            var ziel = document.querySelector('[data-sku], [data-ost]');
            var wort = (block.getAttribute('data-fck-weiter-unten') || '').trim();
            if (ziel && wort && !seiteBedient) {
              var w = document.createElement('button');
              w.type = 'button';
              w.className = 'fck__zweitweg';
              w.textContent = wort.indexOf('%s') > -1
                ? (r.name ? wort.replace('%s', r.name)
                          : wort.replace('%s', '').replace(/  +/g, ' ').trim())
                : wort;
              w.addEventListener('click', function () {
                try { ziel.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
                catch (e2) { ziel.scrollIntoView(); }
              });
              an.appendChild(w);
            }
          }
          if (r.weiter) {
            if (r.weiter.grund) {
              var g = document.createElement('p');
              g.className = 'fck__weiter-grund';
              g.textContent = r.weiter.grund;
              an.appendChild(g);
            }
            var w = document.createElement('a');
            w.className = 'fck__weiter';
            w.textContent = r.weiter.text;
            w.href = r.weiter.href;
            an.appendChild(w);
          }
          if (sackgasse && r.zweitweg && r.zweitweg.href) {
            var z = document.createElement('a');
            z.className = 'fck__zweitweg';
            z.textContent = r.zweitweg.text;
            z.href = r.zweitweg.href;
            an.appendChild(z);
          }
          zeilenEl.appendChild(an);
        }
      });

      if (vfEl && rolle === 'setup') {
        vfEl.hidden = true;
        if (vfHeim && vfEl.parentNode !== vfHeim) vfHeim.appendChild(vfEl);
      } else if (vfEl) {
        var zeilen = zeilenEl.querySelectorAll('[data-fck-z]');
        var inZeile = zeilen.length === 1;
        if (inZeile) zeilen[0].appendChild(vfEl);
        else if (vfHeim) vfHeim.appendChild(vfEl);
        vfEl.classList.toggle('fck__vf--inline', inZeile);
        vfEl.hidden = liste.every(function (r) { return r.stufe === 'rec'; });
      }

      erg.hidden = false;
      if (kopfNeuEl) kopfNeuEl.hidden = false;

      var schlecht = liste.filter(function (r) { return r.stufe === 'warn'; })[0];
      var traeger = schlecht || liste[0];
      document.dispatchEvent(new CustomEvent('3idee:passung', {
        detail: {
          stufe: stufe,
          titel: (traeger.name || '') + ' \u2014 ' + (traeger.wort || ''),
          kurzwort: traeger.wort || WORT[stufe] || WORT.rec,
          kurz: traeger.kurz || '',
          modell: traeger.name || '',
          karten: traeger.karten || '',
          kartenkopf: traeger.kartenkopf || '',
          weiter: traeger.weiter || null,
          monitore: liste.map(function (r) {
            return { ref: r.ref, name: r.name, stufe: r.stufe, wort: r.wort,
                     anzahl: r.anzahl || 1,
                     alternativen: r.alternativen || [],
                     gruende: r.gruende || {},
                     eigenGrund: r.eigenGrund || '',
                     zubehoer: r.zubehoer || [],
                     loesbar: r.stufe !== 'warn'
                              || !!(r.karten && String(r.karten).trim()) };
          })
        }
      }));
    }

    function handleAus(url) {
      var m = /\/products\/([^/?#]+)/.exec(url || '');
      return m ? m[1] : '';
    }


    function karte(p) {
      var ziel = p.in_shop && p.url ? p.url : finderUrl;
      var text = p.name || p.sku;
      var handle = handleAus(p.url);
      var bild = '<span class="fck__vorschlag-ic"'
        + (handle ? ' data-handle="' + esc(handle) + '"' : '') + '>'
        + (p.image_url ? '<img src="' + esc(bildAdresse(p.image_url)) + '" alt="" loading="lazy">' : '')
        + '</span>';

      if (!p.in_shop) {
        return '<a class="fck__vorschlag fck__vorschlag--text" href="' + esc(ziel) + '">'
          + bild
          + '<span class="fck__vorschlag-txt">' + esc(text)
          + ' <small>' + esc(tx('nicht_verknuepft', '— noch nicht im Shop verknüpft')) + '</small></span>'
          + '</a>';
      }

      return '<div class="fck__mini"'
        + (handle ? ' data-mini-handle="' + esc(handle) + '"' : '') + '>'
        + (handle
            ? '<button class="fck__mini-bild" type="button" data-mini-auf'
              + ' aria-label="' + esc(tx('ansehen', '{name} ansehen', { name: text })) + '" tabindex="-1">' + bild + '</button>'
            : bild)
        + '<div class="fck__mini-txt">'
        +   '<span class="fck__mini-titel" data-mini-titel>' + esc(text) + '</span>'
        +   '<span class="fck__mini-preis" data-mini-preis></span>'
        + '</div>'
        + '<span class="fck__mini-aktion" data-mini-aktion></span>'
        + '</div>';
    }

    var abschnitte = {};

    function abschnittHolen(handle) {
      if (abschnitte[handle]) return abschnitte[handle];
      abschnitte[handle] = fetch(WURZEL + 'products/' + handle + '?section_id=mini-produktseite')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var raum = document.createElement('div');
          raum.innerHTML = html;
          var roh = raum.querySelector('[data-mpd-daten]');
          var daten = null;
          try { daten = JSON.parse(roh ? roh.textContent : 'null'); } catch (e) {}
          return { html: html, daten: daten };
        });
      return abschnitte[handle];
    }

    function angebotNachladen(wurzel) {
      wurzel.querySelectorAll('[data-mini-handle]').forEach(function (karte) {
        if (karte.__mini) return;
        karte.__mini = true;
        var handle = karte.getAttribute('data-mini-handle');

        abschnittHolen(handle).then(function (a) {
          var raum = document.createElement('div');
          raum.innerHTML = a.html;

          var titel = raum.querySelector('.pdt');
          var titelEl = karte.querySelector('[data-mini-titel]');
          if (titel && titelEl) {
            var ueberschrift = titel.querySelector('.pdt__titel');
            var wort = ueberschrift ? ueberschrift.innerHTML : titelEl.textContent;
            titelEl.innerHTML = '<button class="fck__mini-titel-knopf" type="button"'
              + ' data-mini-auf>' + wort + '</button>';
          }

          var d = a.daten;
          if (!d) return;

          var anzahl = Number(karte.getAttribute('data-mini-anzahl')) || 1;

          var bildEl = karte.querySelector('[data-mini-bild]');
          if (bildEl && !bildEl.firstElementChild && d.bild) {
            var img = document.createElement('img');
            img.src = d.bild;
            img.alt = '';
            img.loading = 'lazy';
            bildEl.appendChild(img);
          }

          var preisEl = karte.querySelector('[data-mini-preis]');
          if (preisEl && d.preis) {
            preisEl.innerHTML = d.preis + (anzahl > 1 ? '<small>' + esc(tx('pro_stueck', '/ Stück')) + '</small>' : '');
          }

          var aktion = karte.querySelector('[data-mini-aktion]');
          if (!aktion) return;
          var kaufbar = (d.varianten || []).filter(function (v) { return v.kaufbar; });
          var vorlage = raum.querySelector('[data-mpd-kartenform]');

          var mpd = raum.querySelector('.mpd');
          function wort(name, ersatz) {
            return (mpd && mpd.getAttribute('data-mpd-text-' + name)) || ersatz;
          }

          if (!kaufbar.length) {
            aktion.innerHTML = '<button class="fck__mini-ersatz" type="button" disabled>'
              + esc(wort('weg', tx('nicht_verfuegbar', 'Nicht verfügbar'))) + '</button>';
          } else if (!vorlage || !vorlage.content) {
            aktion.innerHTML = '<button class="fck__mini-ersatz" type="button" data-mini-auf>'
              + esc(wort('wahl', tx('auswaehlen', 'Auswählen'))) + '</button>';
          } else {
            var knoten = document.importNode(vorlage.content, true);
            if (anzahl > 1) {
              var mengenfeld = knoten.querySelector('input[name="quantity"]');
              if (mengenfeld) mengenfeld.value = anzahl;
              var kaufform = knoten.querySelector('product-form-component');
              if (kaufform) kaufform.setAttribute('data-quantity-default', anzahl);
            }
            var wahl = knoten.querySelector('.quick-add__button--choose');
            if (wahl) {
              wahl.removeAttribute('on:click');
              wahl.setAttribute('data-mini-auf', '');
            }

            aktion.appendChild(knoten);
            aktion.classList.add('fck__mini-aktion--quick');
          }
        }).catch(function () {});
      });
    }

    function bilderNachladen(wurzel) {
      angebotNachladen(wurzel);
      wurzel.querySelectorAll('[data-handle]:empty').forEach(function (kreis) {
        fetch(WURZEL + 'products/' + kreis.getAttribute('data-handle') + '.js')
          .then(function (r) { return r.json(); })
          .then(function (p) {
            if (!p || !p.featured_image) return;
            var img = new Image();
            img.src = p.featured_image;
            img.alt = '';
            img.loading = 'lazy';
            kreis.appendChild(img);
          })
          .catch(function () {});
      });
    }

    function kartenHtml(recs) {
      var teile = [], vorige = null;
      recs.forEach(function (rec) {
        (rec.products || []).forEach(function (p) {
          if (vorige !== null && rec.alt_group && rec.alt_group === vorige) {
            teile.push('<div class="fck__oder">' + esc(tx('oder', 'oder')) + '</div>');
          }
          teile.push(karte(p));
          vorige = rec.alt_group || null;
        });
      });
      return teile.join('');
    }

    function serviceWeg(name, grund) {
      if (!serviceHref) return null;
      var href = serviceHref;
      if (href.indexOf('wa.me') > -1) {
        href += (href.indexOf('?') > -1 ? '&' : '?') + 'text='
             + encodeURIComponent(name
                 ? tx('wa_modell', 'Hallo, ich habe einen {name} und suche eine passende Befestigung.', { name: name })
                 : tx('wa_seite', 'Hallo, ich brauche Hilfe bei der Passung. Seite: ') + location.origin + location.pathname);
      }
      return { text: serviceText || tx('hilfe_whatsapp', 'Hilfe per WhatsApp'), href: href,
               grund: String(grund || '').trim() };
    }

    function hatEigenes(rec) {
      if (!eigeneSku) return false;
      return (rec.products || []).some(function (p) {
        return String(p.shopify_sku || p.sku || '').trim().toLowerCase() === eigeneSku;
      });
    }

  var PASSUNG_TYPEN = ['ADAPTER', 'PLATE'];

  function loestPassung(rec) {
    return (rec.products || []).some(function (p) {
      return PASSUNG_TYPEN.indexOf(p.type) > -1;
    });
  }

    function bewerte(ref, name) {
      ref = String(ref);

      var ausListe = null;
      if (refs.indexOf(ref) > -1) {
        ausListe = universell
          ? { ref: ref, name: name, stufe: 'ok', wort: tx('sitz_bestaetigt', 'Kompatibel'),
              kurz: tx('sitz_am_geraet', 'An diesem Modell geprüft.') }
          : { ref: ref, name: name, stufe: 'ok', wort: WORT.ok };
      }

      var zubehoer = [];

      return abruf(proxy + '/monitors/' + encodeURIComponent(ref) + '/compatibility')
        .then(function (json) {
          var recs = (json && json.ok && json.data && json.data.recommendations) || [];
          var mit = recs.filter(function (r) { return (r.products || []).length; });

          mit.forEach(function (r) {
            (r.products || []).forEach(function (p) {
              if (p.type !== 'BOLT_SET') return;
              zubehoer.push({ sku: p.shopify_sku || p.sku, handle: p.handle,
                              name: p.name, bild: bildAdresse(p.image_url),
                              stufe: r.requirement, text: r.message || '',
                              imShop: p.in_shop !== false });
            });
          });

          if (ausListe) return ausListe;

          var selbst = mit.filter(hatEigenes);
          if (selbst.length) {
            var zusatz = mit.filter(function (r) {
              return r.requirement === 'REQUIRED' && !hatEigenes(r) && loestPassung(r);
            });
            var eigenGrund = (selbst[0] && selbst[0].message) || '';
            if (zusatz.length) {
              return { ref: ref, name: name, stufe: 'ok', wort: WORT.ok,
                       karten: kartenHtml(zusatz),
                       eigenGrund: eigenGrund,
                       kartenkopf: tx('zusaetzlich_erforderlich', 'Zusätzlich erforderlich') };
            }
            var eigenStufe = (selbst[0] && selbst[0].requirement) || '';
            var kurzUni = eigenStufe === 'REQUIRED' ? tx('sitz_erforderlich', 'Für deinen Monitor erforderlich.')
              : eigenStufe === 'RECOMMENDED' ? tx('sitz_empfohlen', 'Für deinen Monitor empfohlen.')
              : tx('sitz_nicht_einzeln', 'Nicht einzeln geprüft – passt nach VESA-Standard.');
            return { ref: ref, name: name, stufe: 'ok', wort: WORT.ok,
                     eigenGrund: eigenGrund,
                     kurz: universell ? kurzUni : '' };
          }

          var pflichtOhne = recs.filter(function (r) {
            return r.requirement === 'REQUIRED' && !(r.products || []).length;
          });

          if (pflichtOhne.length) {
            var finderZiel = finderUrl
              + (finderUrl.indexOf('?') > -1 ? '&' : '?') + 'finder=neu&setup=1';
            return { ref: ref, name: name, stufe: 'warn', wort: WORT.warn,
                     zweitweg: { text: absageKnopf || tx('passende_loesung', 'Passende Lösung finden'),
                                 href: finderZiel } };
          }

          var pflichtMit = mit.filter(function (r) {
            return r.requirement === 'REQUIRED' && loestPassung(r);
          });
          if (pflichtMit.length) {
            var altHandles = [];
            var gruende = {};
            pflichtMit.forEach(function (rec) {
              (rec.products || []).forEach(function (p) {
                if (!p.in_shop) return;
                var h = handleAus(p.url);
                if (!h) return;
                if (altHandles.indexOf(h) < 0) altHandles.push(h);
                if (!gruende[h] && rec.message) gruende[h] = rec.message;
              });
            });
            return { ref: ref, name: name, stufe: 'warn', wort: WORT.warn,
                     karten: kartenHtml(pflichtMit),
                     alternativen: altHandles,
                     gruende: gruende,
                     kartenkopf: tx('passender_adapter', 'Passender Adapter') };
          }

          if (universell && rolle !== 'setup' && eigeneSku) {
            return abruf(proxy + '/combinations/compatible?m=' + encodeURIComponent(ref)).then(function (j) {
              var ks = (j && j.ok && j.data && j.data.combinations) || [];
              var noetig = ks.length && ks.some(function (k) {
                return (k.requires || []).some(function (r) { return String(r.sku || '').toLowerCase() === eigeneSku; });
              });
              if (noetig) return { ref: ref, name: name, stufe: 'ok', wort: WORT.ok,
                                   kurz: tx('sitz_erforderlich', 'Für deinen Monitor erforderlich.') };
              return null;
            }, function () { return null; });
          }
          if (universell && (rolle !== 'setup' || !zubehoer.length)) return null;

          return { ref: ref, name: name, stufe: 'neutral', wort: WORT.neutral };
        })
        .catch(function (e) {

          var weg = { text: tx('passendes_setup', 'Passendes Setup finden'), href: finderUrl };
          if (ausfall(e)) {
            weg = serviceWeg(name) || { text: tx('modell_per_whatsapp', 'Modell per WhatsApp schicken'),
                                        href: window.EngineStatus.waAdresse(WA_TEXT + name) };
          }

          if (ausListe) return ausListe;

          return { ref: ref, name: name, stufe: 'rec', wort: tx('nicht_geprueft', 'Nicht geprüft'),
                   kurz: tx('abgleich_aus', 'Der Abgleich ist gerade nicht erreichbar.'),
                   weiter: weg };
        })
        .then(function (u) {
          if (u && !u.zubehoer) u.zubehoer = zubehoer;
          return u;
        });
    }

    function pruefeAlle(liste) {
      liste = (liste || []).filter(function (m) { return m && m.ref; });

      var gesehen = {}, gezaehlt = [];
      liste.forEach(function (m) {
        var k = String(m.ref);
        if (gesehen[k]) { gesehen[k].anzahl++; return; }
        gesehen[k] = { ref: m.ref, name: m.name, anzahl: 1 };
        gezaehlt.push(gesehen[k]);
      });
      liste = gezaehlt;

      if (!liste.length) return;
      letzterName = liste[0].name || '';
      letzteAnzahl = liste.length;
      faltZeigen('laedt');
      Promise.all(liste.map(function (m) { return bewerte(m.ref, m.name); }))
        .then(function (ergebnisse) {
          ergebnisse.forEach(function (r, i) {
            if (r) r.anzahl = liste[i].anzahl || 1;
          });
          return ergebnisse;
        })
        .then(zeigeAlle);
    }

    function pruefe(ref, name) { pruefeAlle([{ ref: ref, name: name }]); }

    function suche(q) {
      abruf(proxy + '/monitors/search?q=' + encodeURIComponent(q))
        .then(function (json) {
          if (q !== letzte || !treffer) return;
          var data = (json && json.data) || {};
          var liste = (data.found && data.results && data.results.length)
            ? data.results
            : (data.similar || []);
          if (!json || !json.ok || !liste.length) {
            treffer.innerHTML = '<b>' + esc(tx('kein_treffer', 'Kein Treffer')) + '</b>';
            treffer.hidden = false;
            if (window.Suchebene) window.Suchebene.messen();
            return;
          }
          treffer.innerHTML = '<b>' + esc(tx('meintest_du', 'Meintest du')) + '</b>' + liste.map(function (m) {
            var zus = [];
            if (m.size_inch) zus.push(String(parseFloat(m.size_inch)).replace('.', ',') + '"');
            if (m.year) zus.push(m.year);
            return '<button type="button" data-ref="' + esc(m.ref) + '" data-name="' + esc(m.name) + '">'
              + esc(m.name) + (zus.length ? ' <small>· ' + esc(zus.join(' · ')) + '</small>' : '')
              + '</button>';
          }).join('');
          treffer.hidden = false;
          if (window.Suchebene) window.Suchebene.messen();
        })
        .catch(function (e) {
          if (q !== letzte || !treffer) return;
          if (ausfall(e)) {
            treffer.innerHTML = window.EngineStatus.hinweisHtml(
              tx('suche_aus', 'Die Modellsuche ist gerade nicht erreichbar. Schreib uns dein Modell — wir sagen dir sofort, was passt.'),
              WA_TEXT);
            treffer.hidden = false;
            return;
          }
          treffer.hidden = true;
        });
    }

    if (eingabe) {
      eingabe.addEventListener('input', function () {
        var q = eingabe.value.trim();
        letzte = q;
        clearTimeout(uhr);
        if (q.length < 2) { if (treffer) treffer.hidden = true; return; }
        uhr = setTimeout(function () { suche(q); }, 180);
      });
    }

    function merke(ref, name) {
      try {
        var alt = null;
        try { alt = JSON.parse(localStorage.getItem('3idee_auswahl') || 'null'); } catch (e) {}
        localStorage.setItem('3idee_auswahl', JSON.stringify({
          refs: [ref],
          name: name,
          namen: [name],
          anzahl: 1,
          mount: (alt && alt.mount) || '',
          tisch: (alt && alt.tisch) || null,
          pfad: location.pathname,
          zeit: Date.now()
        }));
        document.dispatchEvent(new CustomEvent('finder:auswahl'));
      } catch (e) {}
    }

    if (treffer) {
      treffer.addEventListener('click', function (e) {
        var b = e.target.closest('[data-ref]');
        if (!b) return;
        var ref = b.getAttribute('data-ref');
        var name = b.getAttribute('data-name');
        merke(ref, name);
        pruefe(ref, name);
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = eingabe ? eingabe.value.trim() : '';
        if (q.length >= 2) { letzte = q; suche(q); }
      });
    }

    block.querySelectorAll('[data-fck-neu]').forEach(function (b) {
      b.addEventListener('click', zeigeEingabe);
    });

    block.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-fh2-wahl-neu]')) zeigeEingabe();

    });

    var auf = block.querySelector('[data-fck-auf]');
    if (auf) {
      auf.addEventListener('click', function () {
        var rest = block.querySelectorAll('.fck__mehr');
        var zu = rest.length ? rest[0].hidden : true;
        rest.forEach(function (s) { s.hidden = !zu; });
        auf.textContent = zu ? auf.getAttribute('data-t-zu') : auf.getAttribute('data-t-auf');
      });
    }

    block.__fckApi = {
      frage: function (q) {
        zeigeEingabe();
        if (eingabe) eingabe.value = q;
        letzte = q;
        suche(q);
      },
      karten: function (wurzel) { angebotNachladen(wurzel); },
      daten: function (handle) {
        return abschnittHolen(handle).then(function (a) { return a.daten; });
      },
      fenster: function (handle, anzahl, geprueft) {
        fensterAuf(handle, Number(anzahl) || 1, geprueft !== false);
      }
    };

    var fenster = block.querySelector('[data-fck-mini-dlg]');
    var fensterLeib = block.querySelector('[data-fck-mini-leib]');

    function fensterAuf(handle, anzahl, gepruft) {
      if (!fenster || !fensterLeib || !handle) return;
      if (!fenster.showModal) { location.href = WURZEL + 'products/' + handle; return; }

      fensterLeib.innerHTML = '<p class="fck__mini-laedt">' + esc(tx('einen_moment', 'Einen Moment …')) + '</p>';
      fenster.showModal();
      abschnittHolen(handle).then(function (a) {
        fensterLeib.innerHTML = a.html;
        var menge = fensterLeib.querySelector('[ref="quantityInput"]');
        if (menge && anzahl > 1) {
          menge.value = anzahl;
          menge.dispatchEvent(new Event('change', { bubbles: true }));
        }

        var pass = fensterLeib.querySelector('[data-mpd-passung]');
        var zeilenZiel = fensterLeib.querySelector('[data-mpd-passzeilen]');
        if (zeilenZiel) {
          zeilenZiel.innerHTML = '';
          (gepruft ? letztesErgebnis : []).forEach(function (r) {
            if (!r || !r.name) return;
            var z = document.createElement('div');
            z.className = 'fck__z-zeile';

            var nameEl = document.createElement('span');
            nameEl.className = 'fck__z-modell';
            nameEl.innerHTML = MONITOR_SVG;
            nameEl.appendChild(document.createTextNode(r.name));
            z.appendChild(nameEl);

            var linie = document.createElement('span');
            linie.className = 'fck__z-linie';
            linie.setAttribute('aria-hidden', 'true');
            z.appendChild(linie);

            var st = document.createElement('span');
            st.className = 'fck__z-status fck__z-status--ok';
            var zei = document.createElement('i');
            zei.setAttribute('aria-hidden', 'true');
            zei.textContent = ZEICHEN.ok;
            st.appendChild(zei);
            st.appendChild(document.createTextNode(
              (pass && pass.getAttribute('data-mpd-wort')) || WORT.ok));
            z.appendChild(st);

            if (gepruft && letztesErgebnis.length === 1) {
              var vf = document.createElement('span');
              vf.className = 'fck__vf fck__vf--inline';
              vf.innerHTML = '<span class="fck__vf-punkt" aria-hidden="true"></span>3IDEE VERIFIED';
              z.appendChild(vf);
            }

            zeilenZiel.appendChild(z);
          });
        }
        var vfUnten = pass && pass.querySelector('[data-mpd-vf]');
        if (vfUnten) vfUnten.hidden = gepruft && letztesErgebnis.length === 1;
        if (pass) pass.hidden = !gepruft || !letztesErgebnis.length;

        fensterBedienen(fensterLeib, a.daten);
      }).catch(function () {
        location.href = WURZEL + 'products/' + handle;
      });
    }

    function fensterBedienen(wurzel, daten) {
      var spur = wurzel.querySelector('[data-mpd-spur]');
      var punkte = wurzel.querySelectorAll('[data-mpd-punkt]');
      if (spur) {
        var zeigen = function (i) {
          var bilder = spur.children;
          if (!bilder.length) return;
          var n = Math.max(0, Math.min(i, bilder.length - 1));
          spur.scrollTo({ left: bilder[n].offsetLeft - spur.offsetLeft, behavior: 'smooth' });
        };
        var aktuell = function () {
          return Math.round(spur.scrollLeft / Math.max(1, spur.clientWidth));
        };
        var vor = wurzel.querySelector('[data-mpd-vor]');
        var zur = wurzel.querySelector('[data-mpd-zur]');
        if (vor) vor.addEventListener('click', function () { zeigen(aktuell() - 1); });
        if (zur) zur.addEventListener('click', function () { zeigen(aktuell() + 1); });
        punkte.forEach(function (pk) {
          pk.addEventListener('click', function () {
            zeigen(Number(pk.getAttribute('data-mpd-punkt')));
          });
        });
        var markieren = function () {
          var n = aktuell();
          punkte.forEach(function (pk, i) {
            pk.setAttribute('aria-current', i === n ? 'true' : 'false');
          });
        };
        spur.addEventListener('scroll', markieren);
        markieren();
      }

      var feldId = wurzel.querySelector('[data-mpd-variante]');
      var kaufKnopf = wurzel.querySelector('[ref="addToCartButton"]');
      var mpd = wurzel.querySelector('.mpd') || wurzel;
      var kaufLabel = mpd.getAttribute('data-mpd-text-kauf') || '';
      var ausLabel = mpd.getAttribute('data-mpd-text-aus') || '';
      var preisEl = wurzel.querySelector('[data-mpd-preis]');
      var auswahlen = wurzel.querySelectorAll('[data-mpd-option]');

      function passendeVariante() {
        if (!daten || !daten.varianten) return null;
        var gewaehlt = [];
        auswahlen.forEach(function (sel) {
          gewaehlt[Number(sel.getAttribute('data-mpd-option'))] = sel.value;
        });
        if (!gewaehlt.length) return daten.varianten[0];
        for (var i = 0; i < daten.varianten.length; i++) {
          var v = daten.varianten[i];
          var passt = true;
          for (var k = 0; k < gewaehlt.length; k++) {
            if (gewaehlt[k] && v.optionen[k] !== gewaehlt[k]) { passt = false; break; }
          }
          if (passt) return v;
        }
        return null;
      }

      function nachziehen() {
        var v = passendeVariante();
        if (!v) return;
        if (feldId) feldId.value = v.id;
        if (preisEl && v.preis) {
          var klein = preisEl.querySelector('small');
          preisEl.innerHTML = v.preis + (klein ? ' ' + klein.outerHTML : '');
        }
        if (kaufKnopf) {
          kaufKnopf.disabled = !v.kaufbar;
          var beschriftung = kaufKnopf.querySelector('.add-to-cart-text__content span span');
          if (beschriftung) beschriftung.textContent = v.kaufbar ? kaufLabel : ausLabel;
        }
      }
      auswahlen.forEach(function (sel) { sel.addEventListener('change', nachziehen); });
      if (auswahlen.length) nachziehen();

    }

    document.addEventListener('shopify:cart:lines-update', function (e) {
      if (!fenster || !fenster.open) return;
      function schliessen() {
        setTimeout(function () { if (fenster.open) fenster.close(); }, 400);
      }
      var fertig = e && e.promise;
      if (fertig && fertig.then) fertig.then(schliessen, schliessen);
      else schliessen();
    });

    block.addEventListener('click', function (e) {
      var auf = e.target.closest && e.target.closest('[data-mini-auf]');
      if (auf) {
        var karte = auf.closest('[data-mini-handle]');
        if (karte) {
          e.preventDefault();
          fensterAuf(karte.getAttribute('data-mini-handle'),
                     Number(karte.getAttribute('data-mini-anzahl')) || 1,
                     true);
        }
        return;
      }

      var zu = e.target.closest && e.target.closest('[data-mpd-zu]');
      if (zu && fenster) { fenster.close(); return; }

    });

    if (fenster) {
      fenster.addEventListener('click', function (e) {
        if (e.target === fenster) fenster.close();
      });
    }

    document.addEventListener('3idee:mini-pdp', function (e) {
      var handle = e.detail && e.detail.handle;
      if (!handle || !fenster || !fenster.showModal) return;
      e.preventDefault();
      fensterAuf(handle, e.detail.anzahl || 1, e.detail.gepruft === true);
    });

    var letzteRefs = '';

    function auswahlUebernehmen() {
      try {
        var roh = localStorage.getItem('3idee_auswahl');
        var a = roh ? JSON.parse(roh) : null;

        if (!a || !a.refs || !a.refs.length) {
          if (letzteRefs !== '') {
            letzteRefs = '';
            zeigeEingabe();
          }
          return;
        }

        var kennung = a.refs.join(',');
        if (kennung === letzteRefs) return;
        letzteRefs = kennung;

        var namen = a.namen || [];
        pruefeAlle(a.refs.map(function (ref, i) {
          return { ref: ref, name: namen[i] || (i === 0 ? a.name : ('Monitor ' + (i + 1))) };
        }));
      } catch (e) {}
    }

    auswahlUebernehmen();
    document.addEventListener('finder:auswahl', auswahlUebernehmen);
  });

  document.querySelectorAll('[data-fck-fern]').forEach(function (band) {
    if (band.__fckFern) return;
    band.__fckFern = true;
    var form = band.querySelector('[data-fck-fern-form]');
    var feld = band.querySelector('[data-fck-fern-input]');
    if (!form || !feld) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = feld.value.trim();
      if (q.length < 2) { feld.focus(); return; }

      var ziel = document.querySelector('[data-fck]');
      if (!ziel || !ziel.__fckApi) {
        var url = band.getAttribute('data-fck-fern-ziel') || '/pages/setup-finder';
        window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + 'q=' + encodeURIComponent(q);
        return;
      }

      ziel.__fckApi.frage(q);
      ziel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      feld.value = '';
    });
  });
})();
